import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationTracker() {
    const location = useLocation();

    // Route changes reset immediately. Only explicit in-page anchors receive
    // smooth motion, and reduced-motion preferences always win.
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (location.hash) {
            const targetId = decodeURIComponent(location.hash.slice(1));
            window.requestAnimationFrame(() => {
                const target = document.getElementById(targetId);
                if (!target) return;
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                target.scrollIntoView({
                    behavior: reduceMotion ? 'auto' : 'smooth',
                    block: 'start',
                });
            });
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [location.pathname, location.hash]);

    // Track page views via Meta Pixel and GA4 on every route change.
    useEffect(() => {
        const pathname = location.pathname;
        const pageName = pathname === '/' ? 'Home' : pathname.replace(/^\//, '').replace(/\//g, '_');

        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
            window.fbq('trackCustom', 'page_view', { page_name: pageName });
        }

        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', {
                page_title: pageName,
                page_location: window.location.href,
                page_path: pathname,
            });
        }
    }, [location]);

    return null;
}
